<template>

  <popup-modal ref="popup">
    <v-card>
      <v-toolbar color="primary" dark>{{$t("dialogs.DialogRestorePassword.toolbarTitle")}}</v-toolbar>

      <v-card-text class="mt-4">
        <v-form>
          <v-row>
            <v-col cols="12">
            {{$t("dialogs.DialogRestorePassword.description")}}
            </v-col>
          </v-row>
          <v-row>
          <v-col cols="12">
            <v-text-field
                v-model="restoreEmail"
                :rules="[validRequired, validEmail]"
                :label="$t('dialogs.DialogRestorePassword.restoreEmailLabel')"
                required
            ></v-text-field>
          </v-col>
          </v-row>

        </v-form>
      </v-card-text>

      <!--                Actions-->
      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn @click="Negative" text >{{$t("common.button_cancel")}}</v-btn>
        <v-btn @click="Positive" color="primary">{{$t("common.button_send")}}</v-btn>
      </v-card-actions>

    </v-card>
  </popup-modal>

</template>


<script>
import PopupModal from "@/components/PopupModal";

export default {
  components: { PopupModal },
  data: () => ({
    restoreEmail: "",
    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  methods:{

    validRequired(v) {
      return !!v || this.$t("dialogs.DialogRestorePassword.validRequiredTitle")
    },
    validEmail(v) {
      return /.+@.+\..+/.test(v) || this.$t("dialogs.DialogRestorePassword.validEmailTitle")
    },



    show(opts = {}) {
      console.log(opts)
      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open(false, true)

      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },


    Positive(){
      this.$refs.popup.close()
      this.resolvePromise({answer: 'positive', email: this.restoreEmail})
    },
    Negative(){
      this.$refs.popup.close()
      this.resolvePromise({answer: 'negative'})
    },
  },
};
</script>
